import CSS from "./static/css/SubmitBtnContainer.module.css";
import Button from "../../../../Component/Elements/Button/Normal/Button";
import { MouseEventHandler } from "react";

const SubmitBtnContainer = (
    {
        cancelBtnHandler,
        selectBtnHandler,
    }:{
        cancelBtnHandler: MouseEventHandler<HTMLButtonElement>;
        selectBtnHandler: MouseEventHandler<HTMLButtonElement>;
    }
) => {
    return(
        <div className={`g_backdrop_filter ${CSS.l_SubmitBtnContainer_main}`}>
            <div className={CSS.l_SubmitBtnContainer_buttonContainer}>
                <Button
                    size={"size1"}
                    onClick={cancelBtnHandler}
                    preset={"cancel"}
                >
                    취소
                </Button>
                <Button
                    size={"size2"}
                    onClick={selectBtnHandler}
                    preset={"save"}
                >
                    사진 선택 완료
                </Button>
            </div>
        </div>
    )
}

export default SubmitBtnContainer;